import { Button } from "@progress/kendo-react-buttons";
import { Completed, NotCompleted } from '../Badges/Badges'

const PortalJobListItem = (props) => {
    const jobCompleteHandler = () => {
        props.onComplete(props.onJobId)
    }

    return (
        <div>
            <div className='jobportal__jobs__item'>
                <div className="jobportal__item__header">
                    <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                        <div className="jobportal__item__text">
                            <p style={{ margin: 0, fontWeight: "600" }}>{props.onJobRef}</p>
                        </div>
                        <div className="jobportal__item__text">
                            <p style={{ margin: 0, fontWeight: "400", marginBottom: "0.5rem" }}>{props.onClient}</p>
                        </div>
                    </div>
                    <div style={{ display: "flex", width: "50%", justifyContent: "flex-end" }}>
                        <div className="jobportal__item__text">
                            <p style={{ margin: 0, fontWeight: "600" }}>{props.onStartDate}</p>
                        </div>
                    </div>
                </div>
                <button className="jobportal__button__jobsheet">Edit Job sheet</button>
                <button className="jobportal__button__complete" onClick={jobCompleteHandler}>Mark as complete</button>
            </div>
        </div>
    )
}

export default PortalJobListItem